enum Color {
  Primary = '#1B4332',
  Secondary = '#0E0A00',
  Grey = '#84818A',
  AccentGreen = '#34C759',
  RedOrange = '#F95738',
  AccentRed = '#FF3B30',
  AccentYellow = '#FF9F38',
  Orange = '#FFA500',
  LightGreen = '#5FC454',
  Purple = '#8338EC',
  DarkBlue = '#001B54',
  LightBlue = '#38D9EC',
  BrightPink = '#F72585',
  LightGray = '#eee',
  DisabledBackground = '#E0E0E0',
  TextDark = '#171725',

  SemiTransparentLightGreen = '#34C75933',
  SemiTransparentRed = '#FF3B3033',
  PrimaryBackgroundTransparent = '#DDE3E1',

  //#region colors to be renamed
  WarningText = '#FFEA00',
  WarningBackground = '#FFAA00',
  NoDataCard = '#A7B3C6',
  Indigo900 = '#312E81',
  Indigo700 = '#4338CA',
  LightGreen2 = '#2F9649',
  LightGreen3 = '#9BD8B1',
  GreyBorder = '#E8E8E8', // todo: finish replacing raw occurences
  WarningYellow = '#FFF7D3',
  MetricPurple = '#7678ED',
  MetricBlue = '#3C8EF9',
  MetricDarkPurple = '#9D4EDD',
  MetricGreen = '#3C6E71',
  MetricDeepBlue = '#03045E',
  MetricLightBlue = '#118AB2',
  MetricDarkPurple2 = '#7209B7',
  MetricGreen2 = '#4F772D',
  MetricPink = '#F72585',
  //#endregion
}

export default Color;
